import { Protocol } from '../Protocol';

export class TestTypeProtocol {
  public static readonly ALL_TEST_TYPE: string = `${Protocol.YATUNG_API_ROOT}/expt/type/all`; // 取得所有試驗類型
}
